export default "__VITE_ASSET__076f242b__"